import React from 'react';
import SelectInput from '../../controls/selectInput.jsx';

export default class BooleanFilter extends React.Component {
    constructor(args) {
        super(args);

        this.state = {
            column: this.props.column,
            value: this.props.value,
            options: [
                {
                    value: '1',
                    label: 'Да'
                },
                {
                    value: '0',
                    label: 'Нет'
                }
            ]
        };

        this.updateLastValue();
    }

    componentWillReceiveProps(newProps) {
        this.state.column = newProps.column;
        this.state.value = newProps.value;
        this.updateLastValue();
        this.setState(this.state);
    }

    updateLastValue() {
        this.lastValue = this.state.value ? this.state.value.value : null;
    }

    applyFilterChanges() {
        this.setState(this.state, () => {
            if (this.state.value) {
                if (this.state.value.value === null || this.state.value.value === undefined || this.state.value.value.length < 1) {
                    // игнорируем пустые значения фильтра
                    return;
                }
                if (this.lastValue === this.state.value.value) {
                    // если ничего не поменялось, сохранять не нужно
                    return;
                }
            } else if (!this.lastValue) {
                // фильтра как не было, так и нет, игнорируем
                return;
            }
            this.updateLastValue();
            this.props.onChange(this.state.column.fieldName, this.state.value);
        });
    }

    clearFilter() {
        this.state.value = null;
        this.applyFilterChanges();
    }

    ensureFilterValue() {
        if (!this.state.value) {
            this.state.value = {
                fieldName: this.state.column.fieldName,
                operation: "equals",
                value: ""
            };
        }
    }

    handleFilterValueChange(selection) {
        if (selection) {
            this.ensureFilterValue();
            this.state.value.value = selection.value;
            this.applyFilterChanges();
        } else {
            this.clearFilter();
        }
    }

    render() {
        let filterValue = this.state.value ? this.state.value.value : "";
        return (
            <div className="input-group">
                <SelectInput options={this.state.options}
                    value={filterValue}
                    onChange={e => this.handleFilterValueChange(e)}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/booleanFilter.jsx